import React from 'react';
import { GlobalOutlined } from '@ant-design/icons';
import { PageHeader, Layout, Tabs } from 'antd';
import { CountriesPage } from './countries-page';
import { CitiesPage } from './cities-page';

export function CountriesMenuPage() {
  const { Content } = Layout;

  return (
    <>
      <PageHeader
        title={
          <>
            <GlobalOutlined /> Ülke ve şehirler
          </>
        }
      />
      <Content style={{ backgroundColor: '#fff' }}>
        <Tabs defaultActiveKey="1">
          <Tabs.TabPane tab="Ülkeler" key="1">
            <CountriesPage />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Şehirler" key="2">
            <CitiesPage />
          </Tabs.TabPane>
        </Tabs>
      </Content>
    </>
  );
}
